import { useContext, useMemo } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationCueSheetInfo } from "../../../../../generated/data-contracts";
import {
  AvisField,
  AvisGrid,
  AvisSection,
} from "../../../../shared/components/form";
import {
  AvisSimpleTable,
  IColumnConfig,
} from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationCueSheetsProps {
  totalTiming: string | undefined;
  data: CreationCueSheetInfo[] | undefined;
}

export function CreationCueSheets(props: Readonly<ICreationCueSheetsProps>) {
  const { res } = useContext(AvisContext);
  const { data, totalTiming } = props;
  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "creationName",
        translation: res("authors_Creation_Section_CueSheet_column_Name"),
      },
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "creationNumber",
        translation: res("authors_Creation_Section_CueSheet_column_Number"),
      },
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "creationUseTypeAvName",
        translation: res("authors_Creation_Section_CueSheet_column_TypeAvName"),
      },
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "soundDuration",
        translation: res(
          "authors_Creation_Section_CueSheet_column_SoundDuration",
        ),
      },
    ];
  }, [res]);
  if (!data) return; //Do not draw section if is not defined

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_CueSheets_Title")}
      textToDisplayKey="portal_RH_CreationCard_AV_2"
    >
      <AvisGrid>
        <AvisField title="Mūzikas hronometrāža" value={totalTiming} />
      </AvisGrid>
      <AvisSimpleTable<CreationCueSheetInfo>
        columnMetadata={columnMetadata}
        data={data}
      />
    </AvisSection>
  );
}
